/**
 * CalendarSyncBanner — Calendar Sync unknown attendees.
 * Thin wrapper around UnknownContactsPanel.
 * Navigating to the demo is surfaced as a meta link in each row.
 */

import UnknownContactsPanel from './UnknownContactsPanel.jsx';

function relDate(dateStr) {
  if (!dateStr) return '';
  const todayISO = new Date().toISOString().slice(0, 10);
  const dISO     = String(dateStr).slice(0, 10);
  if (dISO.length < 10) return '';
  const diff = Math.round((new Date(dISO) - new Date(todayISO)) / 86_400_000);
  if (diff === 0)  return 'today';
  if (diff === 1)  return 'tomorrow';
  if (diff === -1) return 'yesterday';
  if (diff > 1)    return new Date(dISO + 'T12:00:00').toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  return `${-diff}d ago`;
}

export default function CalendarSyncBanner({ items = [], getToken, firms, onNavigateToDemo, onDismiss, onAdd, onHandled }) {
  const normalized = items.map((it) => {
    const parts = [];
    if (it.demo_title) parts.push(`📅 ${it.demo_title}${it.demo_date ? ' · ' + relDate(it.demo_date) : ''}`);

    return {
      email:  it.email,
      meta:   parts.join(' · '),
      source: 'Calendar Sync',
      // store demo_id so the meta click can navigate
      _demo_id: it.demo_id,
    };
  });

  const handleIgnore = onDismiss
    ? (email) => onDismiss(email)
    : null;

  const handleAdd = (prefill) => {
    onAdd?.({ ...prefill, source: 'Calendar Sync' });
    onHandled?.(prefill.email);
  };

  return (
    <UnknownContactsPanel
      title="Calendar Sync"
      icon="📅"
      bgColor="#f0fdf4"
      borderColor="#bbf7d0"
      titleColor="#14532d"
      items={normalized}
      getToken={getToken}
      firms={firms}
      onAdd={handleAdd}
      onIgnore={handleIgnore}
      onHandled={onHandled}
    />
  );
}
